
/**
 * @Description 商圈卡片
 * copy自 src/views/spotevaluation/pages/index/components/AreaDetailDrawer/components/FirstScreenRight/components/Surround/components/Community/index.tsx
 */
import { FC, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
// import { NOT_MORE_DATA } from '../../../../ts-config';
import styles from './index.module.less';

// import VirtualList from 'rc-virtual-list';
import ListItem from './ListItem';
import Empty from '@/common/components/Empty';
import AreaDetailDrawer from '@/common/components/business/YouthMap/AreaDetailDrawer';
import { youthAroundPage, youthShareAroundPage } from '@/common/api/youth';
import V2Pagination from '@/common/components/Data/V2Pagination';

interface BusinessAreaProps {
  mainHeight: number;
  detail: any;
  filters: any;
  setCurDetail: Function;
  isShare?: boolean;
  shareParams?: any; // 分享时才有
  modelConfigId?: any;
  allowSurroundTitleJumpDetail?: boolean;
}
const pageSize = 5;

const BusinessArea :FC<BusinessAreaProps> = ({
  isShare,
  detail,
  filters,
  setCurDetail,
  mainHeight,
  shareParams,
  modelConfigId,
  allowSurroundTitleJumpDetail,
}) => {
  // const ContainerHeight = mainHeight - 100;// tab和分页高度
  // const pageRef: any = useRef<number>(1); // 虚拟列表下拉筛选的分页page
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [list, setList] = useState<any[]>([]);
  const [detailDrawerData, setDetailDrawerData] = useState<any>({ // 开店区域详情抽屉
    open: false,
    id: '',
    // rankVal: null
  });
  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(1); // 当前页数

  const methods = useMethods({
    // onScroll(e: any) {
    //   // 预留10px
    //   if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop <= ContainerHeight + 10) {
    //     if (isLoading) return;
    //     if (pageRef.current !== NOT_MORE_DATA) {
    //       pageRef.current += 1;
    //       methods.loadCommonRimApiData(list);
    //     }
    //   }
    // },
    // 分页相关
    handlePageChange: (value: any) => {
      setIsLoading(true);
      setCurrentPage(value);
      // setPageSize(pageSize);
      methods.loadCommonRimApiData({ page: value });
    },
    loadCommonRimApiData: async (params: any) => {
      // const sizeVal = 200;
      try {
        let _params: any = {};
        const targetFeatch = isShare ? youthShareAroundPage : youthAroundPage;
        _params = {
          // page: pageRef.current,
          size: pageSize,
          poiSearchType: 1,
          aoiTypeCategoryId: filters.aoiTypeCategoryId,
          lat: detail.lat,
          lng: detail.lng,
          radius: filters.distance,
          cityName: detail.cityName,
          modelConfigId,
          modelClusterId: detail.id,
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
          ...(!isNaN(Number(filters?.secondAoiType)) ? { secondAoiType: filters?.secondAoiType } : {}),
          ...params,
        };
        // const { objectList } = await targetFeatch(_params, false);
        // const targetData = isArray(objectList) ? objectList : [];
        // const totalData = [...(isArray(lastData) ? lastData : []), ...targetData];
        // setList(totalData);
        // setIsLoading(false);
        if (!_params.lat || !_params.lng) {
          setIsLoading(false);
          return;
        }
        const { objectList, totalNum: total } = await targetFeatch(_params, {
          needCancel: false
        });
        setTotalNum(total);
        const targetData = isArray(objectList) ? objectList : [];
        setList(targetData);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    // 重置分页
    // pageRef.current = 1;
    // 重新加载列表
    methods.loadCommonRimApiData({
      page: 1,
    });
  }, [filters?.secondAoiType, filters?.distance]);

  return (
    <div className={styles.businessAreaCon} style={{
      maxHeight: `${mainHeight}px`,
      // overflowY: 'auto'
    }}>
      <Spin
        spinning={isLoading}>
        {
          isLoading ? <></> : <>
            {
              Array.isArray(list) && list.length ? <>
                <div style={{
                  maxHeight: `${totalNum > pageSize ? mainHeight - 45 : mainHeight}px`,
                  overflowY: 'auto'
                }}>
                  {
                    list.map((item: any, index: number) => <ListItem
                      key={index}
                      item={item}
                      // curDetail={curDetail}
                      setCurDetail={setCurDetail}
                      shareParams={shareParams}
                      setDetailDrawerData={setDetailDrawerData}
                      allowSurroundTitleJumpDetail={allowSurroundTitleJumpDetail}
                    />)
                  }
                </div>
                {totalNum > pageSize
                  ? <V2Pagination
                    simple={true}
                    disabled={isLoading}
                    current={currentPage}
                    total={totalNum}
                    onChange={methods.handlePageChange}
                    pageSize={pageSize}
                  /> : '' }
                <AreaDetailDrawer
                  modelConfigId={modelConfigId}
                  drawerData={detailDrawerData}
                  setDrawerData={setDetailDrawerData}
                  allowSurroundTitleJumpDetail={false}
                />
              </> : <Empty />
            }
          </>
        }

        {/* {Array.isArray(list) && list.length
          ? <>
            <VirtualList
              data={list}
              height={ContainerHeight}
              itemHeight={146}
              // coder: 陈宇，代码list是双层数组，没有 id这个key，数据构造应该有对象，加个随机id作为key
              itemKey='id'
              onScroll={methods.onScroll}
            >
              {(item: any, index:number) => (
              // <List.Item
              //   key={index}
              // >
                <ListItem
                  key={index}
                  item={item}
                  // curDetail={curDetail}
                  setCurDetail={setCurDetail}
                  shareParams={shareParams}
                  setDetailDrawerData={setDetailDrawerData}
                  allowSurroundTitleJumpDetail={allowSurroundTitleJumpDetail}
                />
              // </List.Item>
              )}
            </VirtualList>
            <AreaDetailDrawer
              modelConfigId={modelConfigId}
              drawerData={detailDrawerData}
              setDrawerData={setDetailDrawerData}
              allowSurroundTitleJumpDetail={false}
            />
          </>
          : <Empty />
        } */}
      </Spin>
    </div>
  );
};


export default BusinessArea;
